﻿import { ajaxPost } from '../../utils/ajax';
import { Vue } from '../../../../js/vue'
export default {
    name: 'di-order-overview-b2c',
    props: ['blockid','viewmodel','collapse'],

    created() {
        var element = document.getElementsByTagName("body")[0];
        element.style.cssText  = "overflow-y:scroll;";
    }, 
    mounted() {
        this.model = this.viewmodel;
        this.subscriptionVisible = this.collapse;
        this.equipmentVisible = this.collapse;
        this.otherVisible = this.collapse;
        this.$store.dispatch('setPageOverview', {'pageOverview': this.model.pageOverview});
        this.setDefaultVisibility(this.model.hardwareInfo.hardwareItems.length);
    },
    computed: {
       
    },
    data: () => ({
        model: {
            pageOverview : {},
            subscriptions: [],
            calculation: {},
            hardwareInfo: {
                hardwareItems: []
            }
        },
        toolTipVisible: false,
        subscriptionVisible: false,
        equipmentVisible: false,
        otherVisible: false,
        toolTipHWVisible: {}
    }),
    methods: {
        setTooltipParagraph: function(tooltipText){          
            return '[{"paragraph":"' + tooltipText + '"}]';
        },
        showToolTip: function() {
            this.toolTipVisible = true;
        },
        hideToolTip: function() {
            this.toolTipVisible = false;
        },
        switchToolTip: function() {
            this.toolTipVisible = !this.toolTipVisible;
        },
        switchEquipmentVisible: function() {
            this.equipmentVisible = !this.equipmentVisible;
        },
        switchSubscriptionVisible: function() {
            this.subscriptionVisible = !this.subscriptionVisible;
        },
        switchOtherVisible: function() {
            this.otherVisible = !this.otherVisible;
        },
        showHWToolTip: function(id) {
            this.$set(this.toolTipHWVisible, id, true);
        },
        hideHWToolTip: function(id) {
            this.$set(this.toolTipHWVisible, id, false);
        },
        switchHWToolTip: function(id) {
            this.$set(this.toolTipHWVisible, id, !this.toolTipHWVisible[id]);
        },
        decodeHtml: function (html) {
            if (html !== undefined) {
                var txt = document.createElement("textarea");
                txt.innerHTML = html;
                return txt.value;
            }

            return "";
        },
        setDefaultVisibility: function(count) {
            for (var i = 0; i < count; i++) {
                this.$set(this.toolTipHWVisible, i, false);
            }
        },
        closePopup: function () {        
            this.$store.dispatch('hideModal');
        }
    },
    ready: function() {        
    }
}